import React, { useCallback, useState } from "react";
import { string } from "prop-types";
import Form from "@insightfulscience/atomic-react/Form";
import FormField from "@insightfulscience/atomic-react/FormField";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import Heading from "@insightfulscience/atomic-react/Heading";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Button from "@insightfulscience/atomic-react/Button";
import { useLocale } from "@insightfulscience/i18";
import Link from "@insightfulscience/atomic-react/Link";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import routes, { navToPath, refs } from "../routes";

const ShareDownloadsForm = ({ regCode }) => {
	const [t] = useLocale("share-downloads-form");

	/** @type {[string, (value: string) => void]} */
	const [code, setCode] = useState(regCode);

	/** @type {[string | null, (value: string | null) => void]} */
	const [error, setError] = useState(regCode ? "errors.SERIAL_NUMBER_NOT_VALID" : null);

	const handleInput = useCallback(
		/** @type {(event: React.ChangeEvent<HTMLInputElement>) => void} */
		event => {
			setCode(event.target.value);
			if (error) setError(null); // reseting an error
		},
		[setCode, error],
	);

	const formSubmit = useCallback(
		/** @type {(event: React.FormEvent<HTMLFormElement>) => void} */
		event => {
			event.preventDefault();

			if (code === "") {
				setError("errors.SERIAL_NUMBER_REQUIRED");
				return;
			}
			navToPath(refs.support.shareDownloads({ r: code.replace(/[^\w]/gi, "") }));
		},
		[code],
	);

	return (
		<SimpleTemplate utility={{ bgColor: "black--02" }} panelPaddingY={8} className="pt-20">
			<Heading Tag="h1" sx={{ fontSize: "xl", textAlign: "center" }}>
				{t("FORM_TITLE")}
			</Heading>
			<Paragraph sx={{ textAlign: "center" }}>
				{t("FORM_SUBTITLE")}{" "}
				<Link
					href="#"
					onClick={e => {
						e.preventDefault();

						// WEB-24076 - Use hard navigation when going from marketing to account
						window.location.pathname = routes.myAccount;
					}}
				>
					{t("MY_ACCOUNT")}
				</Link>
			</Paragraph>
			<Form onSubmit={formSubmit}>
				<Row utility={{ justify: "center" }}>
					<Col>
						<FormField
							name="r"
							label={t("FORM_LABEL")}
							value={code}
							onChange={handleInput}
							required
							error={error && t(error)}
						/>
					</Col>
				</Row>
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={8} sx={{ textAlign: "center" }}>
						<Button type="submit" spacing={{ mt: 10 }} size="m">
							{t("FORM_SUBMIT_BUTTON")}
						</Button>
					</Col>
				</Row>
			</Form>
		</SimpleTemplate>
	);
};

ShareDownloadsForm.propTypes = {
	regCode: string.isRequired,
};
export default ShareDownloadsForm;
